module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": "Formulário de Cadasto de Consulta em Lote",
      "width": "99%",
      "onSave": _vm.salvar,
      "onClose": _vm.fechar
    }
  }, [(_vm.formData.data_age) ? _c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Selecione o(s) Trabalhador(es)\n        ")]), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Trabalhadores",
      "placeholder": "Digite o nome do trabalhador(a)",
      "items": _vm.list.funcionario,
      "loading": _vm.loadingFuncionario,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": function($event) {
        return _vm.formatarFuncionario(_vm.formData.funcionario)
      }
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), _c('ed-input-date', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Data do Agendamento da Consulta",
      "info": "A data do agendamento não garante horário disponível. A disponibilidade deve ser confirmado no dia da consulta diretamente com a clínica que realizará a consulta.",
      "disabled": !_vm.formData.funcionarios.length,
      "yesterdayDisabled": "",
      "tomorrowDisabled": ""
    },
    model: {
      value: (_vm.formData.data_age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_age", $$v)
      },
      expression: "formData.data_age"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Observações",
      "type": "textarea",
      "disabled": !_vm.formData.funcionarios.length
    },
    model: {
      value: (_vm.formData.obs),
      callback: function($$v) {
        _vm.$set(_vm.formData, "obs", $$v)
      },
      expression: "formData.obs"
    }
  }), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 item-group text-left pa-0"
  }, [_vm._v("\n          Informações da Consulta\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formData.funcionarios.length) ? _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('b-table-simple', {
    attrs: {
      "hover": "",
      "small": "",
      "caption-top": "",
      "responsive": ""
    }
  }, [_c('b-thead', {
    staticClass: "table-v2",
    attrs: {
      "head-variant": "light"
    }
  }, [_c('b-tr', [_c('b-th', [_vm._v("Trabalhador")]), _vm._v(" "), _c('b-th', [_vm._v("Função")]), _vm._v(" "), _c('b-th', [_vm._v("Frente de Trabalho")]), _vm._v(" "), _c('b-th', [_vm._v("GHE (Setor)")]), _vm._v(" "), _c('b-th', [_vm._v("Tipo de Consulta")]), _vm._v(" "), _c('b-th', [_vm._v("Remover")])], 1)], 1), _vm._v(" "), _c('b-tbody', _vm._l((_vm.formData.funcionarios), function(funcionario, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.nome) + "\n                "), (_vm.getError(funcionario)) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "7pt"
      }
    }, [_c('br'), _vm._v("\n                  " + _vm._s(_vm.getError(funcionario)) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.funcao ? funcionario.funcao.nome : "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.fdt && funcionario.fdt.pcmso ?
      funcionario.fdt.pcmso +
      " (" +
      funcionario.fdt.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_vm._v(_vm._s(funcionario.ghe && funcionario.ghe.ghe ?
      funcionario.ghe.ghe +
      " (" +
      funcionario.ghe.descricao +
      ")" :
      "---"))]), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('el-collapse', {
      attrs: {
        "title": "Clique para mostrar mais informações"
      },
      model: {
        value: (funcionario.collapse),
        callback: function($$v) {
          _vm.$set(funcionario, "collapse", $$v)
        },
        expression: "funcionario.collapse"
      }
    }, [_c('el-collapse-item', {
      attrs: {
        "name": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [(
      funcionario.collapse && funcionario.collapse[0]
    ) ? _c('i', {
      staticClass: "fa fa-minus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }) : _c('i', {
      staticClass: "fa fa-plus-circle fa-1x mr-1",
      staticStyle: {
        "color": "#28a745"
      }
    }), _vm._v("\n                        " + _vm._s(_vm.formatarTipoConsulta(funcionario)) + "\n                      ")]), _vm._v(" "), _c('ed-input-select-tipo', {
      key: index,
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "name": 'id_tipo_aso_' + index,
        "tipo": "46",
        "isRadio": "",
        "required": ""
      },
      model: {
        value: (funcionario.id_tipo_aso),
        callback: function($$v) {
          _vm.$set(funcionario, "id_tipo_aso", $$v)
        },
        expression: "funcionario.id_tipo_aso"
      }
    }, [(funcionario.id_tipo_aso == 50) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' + index + '_50'
      },
      slot: 'id_tipo_aso_' + index + '_50'
    }, [_c('div', {
      staticClass: "row ml-0 mr-0 mb-0"
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Frente de Trabalho",
        "items": _vm.list.fdt,
        "loading": _vm.loadingFdt,
        "itemText": "fdt",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getGhe(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_fdt),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_fdt", $$v)
        },
        expression: "funcionario.id_mf_fdt"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Novo GHE (Setor)",
        "items": _vm.list.ghe,
        "loading": _vm.loadingGhe,
        "disabled": !funcionario.id_mf_fdt,
        "itemGroup": "",
        "required": ""
      },
      on: {
        "input": function($event) {
          return _vm.getFuncao(funcionario)
        }
      },
      model: {
        value: (funcionario.id_mf_ghe),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_ghe", $$v)
        },
        expression: "funcionario.id_mf_ghe"
      }
    }), _vm._v(" "), _c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Nova Função",
        "items": _vm.list.funcao,
        "loading": _vm.loadingFuncao,
        "disabled": !funcionario.id_mf_fdt ||
          !funcionario.id_mf_ghe,
        "required": ""
      },
      model: {
        value: (funcionario.id_mf_funcao),
        callback: function($$v) {
          _vm.$set(funcionario, "id_mf_funcao", $$v)
        },
        expression: "funcionario.id_mf_funcao"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (
      funcionario.id_tipo_aso == 52 ||
      funcionario.id_tipo_aso == 48
    ) ? _c('div', {
      staticClass: "pb-1",
      attrs: {
        "slot": 'id_tipo_aso_' +
          index +
          '_' +
          funcionario.id_tipo_aso
      },
      slot: 'id_tipo_aso_' +
        index +
        '_' +
        funcionario.id_tipo_aso
    }, [_c('ed-input-select', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
      attrs: {
        "label": "Periodicidade",
        "items": _vm.listaPeriodicidade(funcionario),
        "required": ""
      },
      model: {
        value: (funcionario.periodicidade),
        callback: function($$v) {
          _vm.$set(funcionario, "periodicidade", $$v)
        },
        expression: "funcionario.periodicidade"
      }
    })], 1) : _vm._e()])], 2)], 1)], 1), _vm._v(" "), _c('b-td', {
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "8pt"
      }
    }, [_c('ed-button', {
      attrs: {
        "icon": "fa fa-trash",
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(funcionario)
        }
      }
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cffa649"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/_includes/lote.vue
// module id = 1438
// module chunks = 45